export const PERMISSION_CAN_CREATE_OFFICE = 'can_create_office'
export const PERMISSION_CAN_MANAGE_USER = 'can_manage_users'
export const PERMISSION_CAN_MANAGE_COMPANY = 'can_manage_company'
export const PERMISSION_CAN_MANAGE_LOCATION = 'can_update_offices'
export const PERMISSION_CAN_APPROVE_MASTER_LISTS = 'can_approve_master_lists'
export const PERMISSION_CAN_UPDATE_OFFICES = 'can_update_offices'
